module.exports = __webpack_public_path__ + "static/media/clasihome.9f673702.png";